<template>
  <modal v-model="isVisible">
    <div class="c-modalCard">
      <header class="c-modalCard__header">
        <h4 class="c-modalCard__title">Confirmação para adição de conta</h4>
        <a role="button" class="c-modalCard__close" v-on:click="isVisible = false">
          <i class="i-remove"></i>
        </a>
      </header>
      <div class="c-modalCard__body">
        Faça login na conta do Seller que deseja adicionar.
        <br>
        Caso esteja tentando adicionar a primeira conta ou tentando renovar o token da conta atual, basta ignorar este aviso.
      </div>

      <div class="l-col-12@md">
        <label class="form-checkbox">
          <input type="checkbox" v-model="checked" v-on:click="checked = true">
          <span class="form-checkbox__indicator"></span>
          <span class="form-checkbox__text">Li e entendi</span>
        </label>
      </div>

      <footer class="c-modalCard__footer">
        <button type="button" class="btn"  v-on:click="cancel()">Não</button>
        <button type="button" class="btn btn--success" @click="confirm()">Sim</button>
      </footer>
    </div>
  </modal>
</template>

<script>
  import notifier from '@/notifier'

  export default {
    data: () => ({
      modal: null,
      isVisible: false,
      checked: false
    }),
    props: {
      value: {
        type: Boolean,
        required: true
      },
      callback: {
        type: Function,
        required: false
      }
    },
    created () {
      this.isVisible = this.value
    },
    mounted () {
      this.modal = document.querySelector('div.c-modal')
      this.modal.onclick = (event) => {
        if (event.target === this.modal) {
          this.close()
        }
      }
      document.body.onkeyup = (event) => {
        if (event.code === 'Escape') {
          this.close()
        }
      }
    },
    methods: {
      confirm () {
        if (!this.checked) {
          notifier.error('Por gentileza marcar que leu e entendeu.', 'Erro')
          return false
        }

        this.$emit('confirm', true)
        this.checked = false
        this.close()
      },
      close () {
        delete document.body.onkeyup
        delete this.modal.onclick
        this.isVisible = false
      },
      cancel () {
        this.isVisible = false
        this.checked = false
      }
    },
    watch: {
      isVisible (value) {
        this.$emit('input', value)
      },
      value (value) {
        this.isVisible = value
      }
    }
  }
</script>

  <style lang="sass" scoped>
    .form-checkbox
      margin: 10px

</style>



// WEBPACK FOOTER //
// ModalAddAccount.vue?13830722